










































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import AppBar from "../../components/AppBar.vue";
import Footer from "../../components/Footer.vue";
import ModalDadosBancarios from "../../components/modais/DadosBancarios.vue";
import ModalPontosColeta from "../../components/modais/PontosColeta.vue";

@Component({
  components: { AppBar, Footer, ModalDadosBancarios, ModalPontosColeta }
})
export default class Ajuda extends Vue {
  private isOpenDadosBancarios = false;

  private isOpenPontosColeta = false;

  public created() {
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  }
}
